import L from 'leaflet';
import { TileLayer } from 'react-leaflet';

export const MAPBOX_PUBLIC_TOKEN =
  'pk.eyJ1IjoidmVkYW50aG5hdGgiLCJhIjoiY203c3lnaWwyMGs2ZzJpcmI5ZG1xb253NSJ9.lttVJXspSo8iO2JrkAV72Q';
const MAPBOX_TOKEN = MAPBOX_PUBLIC_TOKEN;

/** Drop-in Mapbox light tile layer for all dashboard maps. */
export function MapboxTileLayer() {
  return (
    <TileLayer
      url={`https://api.mapbox.com/styles/v1/mapbox/light-v11/tiles/{z}/{x}/{y}?access_token=${MAPBOX_TOKEN}`}
      tileSize={512}
      zoomOffset={-1}
      attribution='&copy; <a href="https://www.mapbox.com/about/maps/">Mapbox</a> &copy; <a href="https://www.openstreetmap.org/copyright">OSM</a>'
    />
  );
}

// Vite bundler-safe icon fix — Leaflet's default markers use require()
// path resolution that breaks in bundled builds.
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png';
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({ iconUrl, iconRetinaUrl, shadowUrl });

/** Colored circle div-icon for supervisor / employee pins. */
export function makeCircleIcon(color, size = 18) {
  return L.divIcon({
    className: '',
    html: `<div style="width:${size}px;height:${size}px;background:${color};border-radius:50%;border:2px solid white;box-shadow:0 1px 3px rgba(0,0,0,0.35)"></div>`,
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
    popupAnchor: [0, -(size / 2 + 4)],
  });
}

export { L };
